import React from "react";
import Navigation from "./Navigation";
import { ReactComponent as InfoIcon } from "images/info.svg";
class QuestionQ22 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: "none",
    };
  }

  showHover = () => {
    this.setState({ display: "block" });
  };

  hideHover = () => {
    this.setState({ display: "none" });
  };

  render() {
    const Q22 =
      this.props.Q45 == "Système solaire combiné"
        ? "Q22-solaire"
        : this.props.name;
    const itemsMobile = this.props.dataItems[Q22].items.map((item) => (
      <div className="item-container-m" key={item.long}>
        <label>
          <div
            className={
              this.props.data == item.short ? "item item-checked" : "item"
            }
          >
            <item.icon
              className="item-icon"
              alt={item.short}
              width="30"
              height="35"
            />{" "}
            <span>{item.long}</span>
          </div>
          <input
            type="radio"
            name={this.props.name}
            value={item.short}
            onChange={this.props.handleData}
            className="is-hidden"
          />
        </label>
      </div>
    ));

    const items = this.props.dataItems[Q22].items.map((item) => (
      <div className="item-container" key={item.long}>
        <label>
          <div
            className={
              this.props.data == item.short ? "item item-checked" : "item"
            }
          >
            <div className="img">
              <item.icon className="item-icon" alt={item.short} />
            </div>
            <div className="d-flex">
              <span
                className={this.props.data == item.short ? "text-sub2" : ""}
              >
                {item.long}
              </span>
              {item.tooltip && (
                <div
                  className="info-block-container is-hidden-mobile"
                  onMouseEnter={(e) => this.showHover(e)}
                  onMouseLeave={(e) => this.hideHover(e)}
                >
                  <div
                    className="iconColor1"
                    style={{ float: "right", marginLeft: "5px" }}
                  >
                    <InfoIcon />
                  </div>
                  <div
                    className="info-block info-block-bailleur"
                    style={{ display: this.state.display }}
                  >
                    <h3>Propriétaire bailleur : </h3>
                    <p className="mt-10">
                      <strong>Un bailleur</strong> désigne une personne physique
                      ou morale (banque, mutuelle, compagnie d'assurance),
                      généralement <strong>propriétaire</strong> d'un bien
                      immobilier et qui met celui-ci en location.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="d-flex mb-30">
            <div>
              <div>
                <input
                  type="radio"
                  name={this.props.name}
                  value={item.short}
                  onChange={this.props.handleData}
                  className="is-hidden"
                />
              </div>
            </div>
            <div className={item.long.length > 18 ? "lh16" : "lh22"}></div>
          </div>
        </label>
      </div>
    ));

    console.log("?", this.props.dataItems[this.props.name].items.length);
    return (
      <div className="fadeIn">
        <div
          className={
            this.props.dataItems[Q22].items.length > 3
              ? "item-wrapper is-hidden-mobile"
              : "item-wrapper jcc is-hidden-mobile"
          }
        >
          {items}
        </div>
        <div className="only-show-mobile">{itemsMobile}</div>

        <Navigation
          data={this.props.data}
          step={this.props.step}
          nextStep={this.props.nextStep}
          lastStep={this.props.lastStep}
          loadingParcours={this.props.loadingParcours}
          leadsource={this.props.leadsource}
          lastStepPrequestion={this.props.lastStepPrequestion}
        />
      </div>
    );
  }
}

export default QuestionQ22;
